import { AxiosResponse } from 'axios';
import Api from './api';

const DocumentsApi = (): Promise<AxiosResponse> => {
  const path = `/admin/list/documents`;
  return Api.getInstance().request.get(path);
};
export default DocumentsApi;
